import ApiClient from '@services/ApiClient';

export default {
    getTour(code) {
        return ApiClient.get(`/tours/${code}`);
    },

    sendInquiry(data) {
        return ApiClient.post('/tours/inquiry', data);
    },
};
